import React from 'react';
import './paperwork.css';
import { COMPANY } from '../../constants/company';

const Header = () => (
  <div className="flex items-start justify-between">
    <div className="flex items-center gap-2">
      <svg viewBox="0 0 40 40" className="w-10 h-10">
        <circle cx="20" cy="20" r="20" fill="#1F0068" />
        <path d="M12 22 L18 28 L28 14" fill="none" stroke="#FF5C39" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div className="leading-tight">
        <div className="font-bold text-[15px] text-[#1F0068]">{COMPANY.shortName}</div>
        <div className="text-[9px] tracking-[0.22em] text-[#FF5C39] uppercase font-semibold">{COMPANY.tagline}</div>
      </div>
    </div>
    <div className="text-right text-[10px] text-[#1F0068]/70 leading-relaxed">
      <div>{COMPANY.phone}</div>
      <div>{COMPANY.email}</div>
      <div>{COMPANY.website}</div>
      <div>{COMPANY.registeredOffice.full}</div>
    </div>
  </div>
);

export const WelcomeLetter = ({ policy }) => {
  const fullName = `${policy.title} ${policy.firstName} ${policy.lastName}`;
  return (
    <div className="a4-doc">
      <div className="a4-brand-strip" />
      <Header />

      <div className="mt-10 grid grid-cols-[1fr_auto] gap-4 items-start">
        <div className="text-[11px] text-[#1F0068]/80">
          <div className="font-bold text-[#1F0068]">{fullName}</div>
          <div>{policy.address1}</div>
          {policy.address2 && <div>{policy.address2}</div>}
          <div>{policy.city}</div>
          <div>{policy.postcode}</div>
        </div>
        <div className="grid grid-cols-3 gap-2 text-[10px]">
          <div className="bg-[#FFF6EB] rounded-lg p-2 text-center">
            <div className="uppercase tracking-widest text-[#1F0068]/60 font-bold text-[9px]">Joining Date</div>
            <div className="font-bold text-[#1F0068]">{new Date(policy.policyStart).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
          </div>
          <div className="bg-[#FFF6EB] rounded-lg p-2 text-center">
            <div className="uppercase tracking-widest text-[#1F0068]/60 font-bold text-[9px]">Amount</div>
            <div className="font-bold text-[#1F0068]">£ {Number(policy.amount).toFixed(2)}</div>
          </div>
          <div className="bg-[#FFEDD6] rounded-lg p-2 text-center">
            <div className="uppercase tracking-widest text-[#1F0068]/60 font-bold text-[9px]">Plan Number</div>
            <div className="font-bold text-[#1F0068]">{policy.planNumber}</div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <div className="text-[13px] text-[#1F0068]/85">Dear, {policy.firstName} {policy.lastName}</div>
        <h1 className="mt-2 text-3xl font-extrabold leading-tight">Welcome to your<br /><span className="text-[#FF5C39]">Domestic Home Services</span> Maintenance Cover Plan</h1>
        <p className="mt-4 text-[12px] leading-relaxed text-[#1F0068]/85">
          Thank you for choosing Domestic Home Services for maintenance cover of your home appliances. Please find enclosed and detailed hereafter the terms and conditions for your appliance maintenance cover plan or plan(s) and information. Please take the time to read over this carefully and do not hesitate to get in contact with us should you have any questions, queries, or amendments to make.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-3 gap-3 text-[11px]">
        <div className="bg-[#FFF6EB] rounded-xl p-3">
          <div className="font-bold text-[#1F0068] mb-1">This unique warranty operates on a disciplinary basis.</div>
          <div className="text-[#1F0068]/80">We treat all customers with fairness, understanding and courtesy and hope they have resulted in excellent satisfaction scores and positive testimonials from happy customers.</div>
        </div>
        <div className="bg-[#FFEDD6] rounded-xl p-3">
          <div className="font-bold text-[#1F0068] mb-1">We only accept direct bank transfer payments.</div>
          <div className="text-[#1F0068]/80">To protect your personal data and financial information, we only accept payments via direct bank transfer. We do not accept card payments, cheques or any other payment methods.</div>
        </div>
        <div className="bg-[#FCE0EC] rounded-xl p-3">
          <div className="font-bold text-[#1F0068] mb-1">You’re all set to enjoy complete peace of mind.</div>
          <div className="text-[#1F0068]/80">Our protection is here when you need it most. If you need anything at all don’t hesitate to get in touch with our friendly team.</div>
        </div>
      </div>

      <div className="mt-6 bg-[#1F0068] text-white rounded-xl p-4">
        <div className="text-[10px] uppercase tracking-widest text-white/70 font-bold">Useful Contact Details</div>
        <div className="grid grid-cols-2 mt-2 text-[12px]">
          <div><div className="text-white/70 text-[10px]">Helpline Number</div><div className="font-bold">{COMPANY.phone}</div></div>
          <div><div className="text-white/70 text-[10px]">Email</div><div className="font-bold">{COMPANY.email}</div></div>
        </div>
      </div>

      <div className="mt-6 text-[12px] text-[#1F0068]/85">
        <div>Yours sincerely,</div>
        <div className="mt-1" style={{ fontFamily: 'cursive', fontSize: '18px', color: '#1F0068' }}>Team Domestic Home Services</div>
        <div className="text-[10px] text-[#1F0068]/60">Customer Service Team</div>
      </div>

      <div className="mt-4 text-[10px] italic text-[#1F0068]/70">
        Please read the enclosed policy wording carefully as it contains information about the policy including Terms & Conditions, How to Make a Claim, Important Contact Information and Your Cancellation Rights.
      </div>

      <div className="a4-footer">
        <div>{COMPANY.name} · {COMPANY.registeredOffice.full}</div>
        <div>Company No. {COMPANY.companyNumber} · Page 01 · Plan {policy.planNumber}</div>
      </div>
    </div>
  );
};

export default WelcomeLetter;
